import slider from '../helpers/slider';
import wait from '../helpers/wait';
import lazyLoader from './lazyLoader';
import reveal from '../helpers/reveal';
import { TinySliderSettings } from 'tiny-slider';

interface IInstagramFeedConfig {
  htmlElement: HTMLElement,
  selectors: IInstagramFeedSelectors,
  slider: IInstagramFeedSlider
}

interface IInstagramFeedSlider {
  htmlElement: HTMLElement,
  settings: TinySliderSettings,
  imgs: NodeList
}

interface IInstagramFeedSelectors {
  main: string,
  slider: string,
  img: string
}

class InstagramFeed {

  private config: IInstagramFeedConfig;

  constructor() {
    this.config = {
      htmlElement: null,
      slider: {
        htmlElement: null,
        imgs: null,
        settings: {
          // @ts-ignore
          prevButton: document.querySelector('[data-instafeed-prev-button]'),
          nextButton: document.querySelector('[data-instafeed-next-button]'),
          loop: false,
          responsive: {
            1024: {
              items: 4,
              gutter: 10,
              controls: true,
              disable: false
            }
          }
        }
      },
      selectors: {
        main: '[data-instagram-feed]',
        slider: '[data-instagram-feed-slider]',
        img: '[data-instagram-feed-slider] > a img[src].js-lazy-image'
      }
    }
  }

  public init() {
    document.querySelectorAll(this.config.selectors.main).forEach((htmlElement: HTMLElement) => {
      // this.load(htmlElement);
    });
  }

  public async load(htmlElement: HTMLElement) {
    this.config.htmlElement = htmlElement;
    this.config.slider.imgs = await wait.forNodeList(this.config.selectors.img, 100, 100);
    this.config.slider.htmlElement = this.config.htmlElement.querySelector(this.config.selectors.slider);
    if (this.config.slider.imgs) lazyLoader.add(this.config.slider.imgs), lazyLoader.update();
    if (this.config.slider.htmlElement) this.slider();
    if (this.config.htmlElement && this.config.slider.imgs.length) reveal.closestHideClassName(this.config.htmlElement);
  }

  private slider() {
    return slider.init(this.config.slider.htmlElement, this.config.slider.settings);
  }
}

export default new InstagramFeed();